import React from "react"

import styles from "./TopHeader.module.css"
import iconBack from "../../assets/iconBack.svg"
import {useNavigate} from "react-router-dom";

function TopHeader({ title }) {
	const navigate = useNavigate()

	return (
		<>
			<div className={styles.TopHeader}>
				<button type="button" onClick={e => {
					e.preventDefault()
					navigate(-1)
				}}>
					<img src={iconBack} alt="뒤로가기" />
				</button>
				<h3>{ title }</h3>
			</div>
		</>
	)
}

export default TopHeader
